<template>
  <div class="navBar nav-bars">
    <header>
      <van-nav-bar
        :left-arrow="showBack && closeBack"
        :title="title"
        @click-left="clickleft()"
      >
        <template v-if="showType === 'text' && closeMenu">
          <svg
            slot="right"
            class="icon"
            aria-hidden="true"
            @click="openMenu"
          >
            <use xlink:href="#icon-caidan" />
          </svg>
        </template>
        <template v-if="showType === 'icons'">
          <!-- <svg slot="title" class="icon icon-logo" aria-hidden="true" v-if="showLogo">
            <use xlink:href="#icon-logo" />
          </svg>-->
          <!-- 顶部logo跳转到首页 -->
          <svg
            v-if="showLogo"
            slot="title"
            class="icon icon-logo"
            aria-hidden="true"
            @click="link()"
          >
            <use xlink:href="#icon-logo" />
          </svg>

          <span
            v-if="showMap"
            slot="right"
            class="span"
          >
            <router-link to>
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-ditu" />
              </svg>
            </router-link>
          </span>
          <span
            v-if="showMore"
            slot="right"
            class="span"
          >
            <router-link to>
              <svg
                class="icon"
                aria-hidden="true"
                @click="showMoreEvent"
              >
                <use xlink:href="#icon-gengduox" />
              </svg>
            </router-link>
          </span>
          <span
            slot="right"
            class="span"
            @click="openMenu"
          >
            <svg
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-caidan" />
            </svg>
          </span>
        </template>
      </van-nav-bar>
    </header>
    <!-- 弹出层 -->
    <van-popup
      v-model="showPop"
      position="right"
      :overlay="false"
    >
      <header class="header">
        <van-nav-bar
          left-arrow
          class="tool_top"
          @click-left="showPop = false"
          @click-right="showPop = false"
        >
          <!-- <svg slot="title" class="icon icon-logo" aria-hidden="true">
            <use xlink:href="#icon-logo" />
          </svg>-->
          <!-- 顶部跳转到首页 -->

          <svg
            v-if="showLogo"
            slot="title"
            class="icon icon-logo"
            aria-hidden="true"
            @click="link()"
          >
            <use xlink:href="#icon-logo" />
          </svg>

          <span
            slot="right"
            class="span"
          >
            <svg
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-caidan" />
            </svg>
          </span>
        </van-nav-bar>
      </header>
      <section>
        <div class="section">
          <h3>{{ lang.tools.buy.title }}</h3>
          <ul>
            <li
              v-for="item in buyHouse"
              :key="item.id"
            >
              <a :href="item.href">
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use :xlink:href="item.svg" />
                </svg>
                <p>{{ item.text }}</p>
              </a>
            </li>
          </ul>
        </div>
        <div class="section">
          <h3>{{ lang.tools.rent.title }}</h3>
          <ul>
            <li
              v-for="item in rentHouse"
              :key="item.id"
            >
              <a :href="item.href">
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use :xlink:href="item.svg" />
                </svg>
                <p>{{ item.text }}</p>
              </a>
            </li>
          </ul>
        </div>
        <div class="section">
          <h3>{{ lang.tools.landlord.title }}</h3>
          <ul>
            <li
              v-for="item in landlord"
              :key="item.id"
            >
              <a :href="item.href">
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use :xlink:href="item.svg" />
                </svg>
                <p>{{ item.text }}</p>
              </a>
            </li>
          </ul>
        </div>
        <div class="tools">
          <!-- 调整 -->
          <h3>{{ lang.tools.tools.title }}</h3>
          <div class="div-tools">
            <ul :class="{'tools-ul': true, 'w650': curLang == '/en-us'}">
              <li
                v-for="item in tools"
                :key="item.id"
                class="lastTools"
              >
                <a :href="item.href">
                  <div class="text">
                    <p>{{ item.text }}</p>
                  </div>
                  <img
                    v-if="item.id == 6"
                    src="../assets/zhiyebaike.svg"
                    alt=""
                    style="vertical-align: middle;"
                  >
                  <div
                    v-else
                    class="svg"
                  >
                    <svg
                      class="icon"
                      aria-hidden="true"
                    >
                      <use :xlink:href="item.svg" />
                    </svg>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </van-popup>
  </div>
</template>

<script>
// import { NavBar, Popup } from 'vant';
// import "vant/lib/button/style";
import guide from './../components/guide';
import lang from './../../common/language/index';
const _conf = require('../../common/js/_conf');
export default {
  name: 'NavBar',
  components: {
    // [NavBar.name]: NavBar,
    // [Popup.name]: Popup,
    guide
  },
  props: {
    title: { type: String, required: true },
    showType: { type: String, default: 'icons' },
    showLogo: { type: Boolean, default: true },
    showMap: { type: Boolean, default: true },
    showMore: { type: Boolean, default: true },
    showBack: { type: Boolean, default: true }
  },
  data() {
    return {
      host: '',
      lang: lang,
      curLang: '',
      showPop: false,
      isOpen: false,
      buyHouse: [],
      rentHouse: [],
      landlord: [],
      tools: [],
      closeMenu: true,
      closeBack: true
    };
  },
  created() {
    this.host = location.origin;
    this.base = _conf.env_type == 4 ? 'https://simm.house730.com':_conf.env_type == 3 ?'https://m.house730.com':'https://uatm.house730.com.cn'
    this.base2 = _conf.env_type == 4 ? 'https://sim.house730.com':_conf.env_type == 3 ?'https://house730.com':'https://uat.house730.com.cn'
    this.curLang = window._language === 'en-us' ? '/en-us' : window._language === 'zh-hk' ? '' : '/zh-cn';
    this.buyHouse = [
      {
        id: 1,
        text: lang.search,
        svg: '#icon-zhuzhai',
        href: `${this.host}${this.curLang}/buy/`
      },
      {
        id: 3,
        text: lang.tools.buy.mapSearch,
        svg: '#icon-mapSearch',
        href: `${this.host}${this.curLang}/map/?type=sale`
      },
      {
        id: 4,
        text: lang.tools.buy.new,
        svg: '#icon-soldPrices',
        href: `${this.host}${this.curLang}/new-properties/hk1/`
      },
      {
        id: 6,
        text: lang.tools.buy.vr,
        svg: '#icon-VR-shouye',
        href: `${this.host}${this.curLang}/buy/v1/`
      }
    ];
    this.rentHouse = [
      {
        id: 1,
        text: lang.rentSearch,
        svg: '#icon-zhuzhai',
        href: `${this.host}${this.curLang}/rent/`
      },
      {
        id: 3,
        text: lang.tools.rent.mapSearch,
        svg: '#icon-mapSearch',
        href: `${this.host}${this.curLang}/map/?type=rent`
      },
      {
        id: 5,
        text: lang.tools.buy.vr,
        svg: '#icon-VR-shouye',
        href: `${this.host}${this.curLang}/rent/v1/`
      }
    ];
    this.landlord = [
      {
        id: 1,
        text: lang.tools.landlord.postProperty,
        svg: '#icon-postProperty',
        href: `${this.base}/my${this.curLang}/post/`
      },
      {
        id: 2,
        text: lang.tools.landlord.listingFees,
        svg: '#icon-listingFees',
        href: `${this.base2}${this.curLang}/help/charge/`
      },

      {
        id: 3,
        text: lang.tools.landlord.memberCentre,
        svg: '#icon-memberCentre',
        href: `${this.base}/my${this.curLang}/`
      },
      {
        id: 4,
        text: lang.tools.landlord.myListings,
        svg: '#icon-myListings',
        // href: `${this.host}/my${this.curLang}/my-properties/`
        href: `${this.base}/my${this.curLang}/my-properties/`
      }
    ];
    this.tools = this.curLang == '/en-us' ? [
       {
        id: 5,
        text: lang.tools.tools.data,
        svg: '#icon-chengjiaojilu',
        // href: `${this.host}${this.curLang}/data`
        href: `${this.host}${this.curLang}/deal/`
      },
      {
        id: 2,
        text: lang.tools.tools.mortgageCal,
        svg: '#icon-mortgageCalTool',
        // href: `http://testtools.house730.com${this.curLang}/tax/`
        href:`http://tools.house730.com/taxpc/${this.curLang}`
      },
      {
        id: 3,
        text: lang.tools.tools.contactUs,
        svg: '#icon-contactUs',
        // href: `${this.host}${this.curLang}/contact-us/`
        href: `${this.base2}${this.curLang}/help/contactus/`
      },
      {
        id: 4, // House730 facebook
        text: lang.tools.tools.facebook,
        svg: '#icon-facebook',
        href: '//www.facebook.com/House730-464562354371140/'
      }
    ] : [
      {
        id: 1,
        text: lang.tools.tools.news,
        svg: '#icon-news',
        href: `${this.host}${this.curLang}/news/`
      },
      {
        id: 6,
        text: lang.tools.tools.propertyTips,
        svg: '#icon-zhiyebaike',
        // href: `https://sim.house730.com${this.curLang}/property-tips/${encodeURI(lang.tools.tools.propertyTips)}/`,
        // 线上地址
        href: `https://www.house730.com${this.curLang}/property-tips/${encodeURI(lang.tools.tools.propertyTips)}/`
        // target: 'propertyTips',
        // enShow: this.curLang == 'en-us' ? false : true
      },
      {
        id: 5,
        text: lang.tools.tools.data,
        svg: '#icon-chengjiaojilu',
        href: `${this.host}${this.curLang}/deal/`
      },
      {
        id: 2,
        text: lang.tools.tools.mortgageCal,
        svg: '#icon-mortgageCalTool',
        // href: `http://testtools.house730.com${this.curLang}/tax/`
        href:`http://tools.house730.com/taxpc/${this.curLang}`
      },
      {
        id: 3,
        text: lang.tools.tools.contactUs,
        svg: '#icon-contactUs',
        // href: `${this.host}${this.curLang}/contact-us/`
        href: `${this.base2}${this.curLang}/help/contactus/`
      },
      {
        id: 4, // House730 facebook
        text: lang.tools.tools.facebook,
        svg: '#icon-facebook',
        href: '//www.facebook.com/House730-464562354371140/'
      }
    ];
    // var obj = {
    //   id: 5,
    //   text: lang.tools.tools.data,
    //   svg: '#icon-chengjiaojilu',
    //   href: `${this.host}${this.curLang}/data`
    // };
    // this.tools.unshift(obj);
  },
  mounted() {
    this.hideBack();
  },
  methods: {
    link() {
      let language = this.pub.getLang();
      /**跳转到主页面 */
      const host = location.origin + '/' + (language == 'zh-hk' ? '' : language);
      location.href = host;
    },
    hideBack() {
      if (this.$route.query.fromapp || sessionStorage.getItem('fromapp')) {
        sessionStorage.setItem('fromapp', '1');
        this.closeMenu = false;
        this.closeBack = false;
      }
    },
    openMenu() {
      this.showPop = true;
    },
    showMoreEvent() {
      this.isOpen = !this.isOpen;
    },
    clickleft() {
      if (this.$route.fullPath.indexOf('/login') > -1) {
        history.go(-1);
        // let curLang = this.pub.getLang(this.$route.path) || '';
        // curLang = curLang == 'zh-hk' ? '' : curLang + '/';

        // window.location.href = this.pub.config.wapUrl + curLang;
      } else if (this.$route.query.url) {
        window.location.href = location.origin + this.$route.query.url;
      } else {
        this.$router.push('/');
      }
    }
  }
};
</script>

<style scoped lang="scss">
.navBar {
  position: relative;
  .van-nav-bar {
    border-bottom: #ececec solid 1px;
  }
  .van-popup--right {
    height: 100%;
    width: 100%;
  }
  .van-icon {
    color: #423f3f;
  }
  .van-icon-arrow-left {
    font-size: 22px;
  }
}
.van-nav-bar {
  position: relative;
  font-size: 24px;
  .van-nav-bar__title .icon {
    font-size: 42px;
  }
  .van-nav-bar__right .icon {
    font-size: 18px;
    margin-left: 12px;
  }
}
/deep/ .van-overlay {
  background-color: transparent;
}
/* 彈出框菜單 */
.header {
  width: 100%;
  height: 44px;
  position: relative;
  background-color: #fff;
}
.dropdown-menu {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ececec;
  border-radius: 5px;
  right: 10px;
  z-index: 999999;
  top: 50px;
  a {
    padding: 6px 25px;
    display: block;
    color: #666;
    font-size: 14px;
  }
}
section {
  box-sizing: border-box;
  padding: 20px;
  text-align: left;
  .section {
    h3 {
      font-size: 15px;
      width: 32%;
      text-align: center;
      margin-bottom: 10px;
      font-weight: bold;
    }
    ul {
      border-top: 1px solid #eee;
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-around;
      text-align: center;
      margin-bottom: 30px;
      li {
        width: 25%;
        margin-top: 20px;
        a {
          display: inline-block;
          width: 100%;
        }
        .icon {
          font-size: 30px;
        }
        p {
          font-size: 12px;
          color: #333333;
          letter-spacing: 0.14px;
          text-align: center;
          margin-top: 10px;
        }
      }
      li.lastTools {
        height: 67px;
        a {
          text-align: right;
        }
        .icon {
          font-size: 35px;
          margin-top: 10px;
          text-align: right;
        }
      }
    }
  }
}
.tools {
  box-sizing: border-box;
  text-align: left;
  h3 {
    font-weight: bold;
    font-size: 15px;
    width: 32%;
    text-align: center;
    margin-bottom: 10px;
  }
  .div-tools {
    width: 100%;
    overflow-x: auto;
  }
  ul {
    padding: 20px;
    border-top: 1px solid #eee;
    width: 840px;
    display: block;
    li {
      overflow: hidden;
      margin-top: 20px;
      height: 54px;
      line-height: 54px;
      .text {
        color: #333;
        float: left;
        font-size: 14px;
        padding-right: 6px;
      }
      .svg {
        float: left;
        line-height: 64px;
        .icon {
          font-size: 30px;
        }
      }
    }
  }
}

.lastTools {
  background: #f5f8fc;
  padding: 5px;
  margin-right: 8px;
  display: inline-block;
}
.w650 {
  width: 650px!important;
}
</style>
